// extracted by mini-css-extract-plugin
export var head = "discounts-module--head--uce19";
export var root = "discounts-module--root--KeYgF";